// modal.js
export const Modal = {
    open() {
        document.body.classList.add("modal-open");
    },

    close() {
        document.body.classList.remove("modal-open");
    }
};
